import React from 'react'
import GenericModal from '../../../components/GenericModal'
import { Typography } from '@mui/material'
import { ButtonType } from '../../../components/GenericButton/styles'

interface SyncSectionAlertModalProps {
  isOpen: boolean
  onClose: () => void
}

const SyncSectionAlertModal: React.FC<SyncSectionAlertModalProps> = ({ isOpen, onClose }) => {
  return (
    <GenericModal
      isOpen={isOpen}
      onClose={onClose}
      title="Course Sections are Syncing in the background"
      maxWidth="sm"
      hideConfirmButton
      destructiveButtonType={ButtonType.Primary}
      destructiveButtonText='OK'
    >
      <Typography mt={3}>
        Your course sections are syncing in the background. You can keep working while this runs. Come back later or refresh to see changes.
      </Typography>
    </GenericModal>
  )
}

export default SyncSectionAlertModal
